import { UPDATE_SAWMILL_LIST } from '../store/sawmill';

import { ApiService } from '../services/apiService';
import { notificationActions } from './notificationActions';
import { ApplicationState, AppDispatch } from 'store';
import { AxiosError } from 'axios';
import { SawmillResponse } from '.generated/api';

export const sawmillActions = {
  getSawmillsByOrganizationId,
  addSawmillToOrganization,
  renameSawmill,
  deleteSawmill,
  addUserToSawmill,
  assignStacksToSawmill,
  updateSawmillUser,
  removeSawmillUser,
};

function updateSawmillList(sawmills?: SawmillResponse[]) {
  return { type: UPDATE_SAWMILL_LIST, sawmills };
}

function getSawmillsByOrganizationId(organizationId: string) {
  return (dispatch: AppDispatch) => {
    dispatch(updateSawmillList());
    ApiService.getSawmillList({ organizationId, page: 1, pageSize: 1000 })
      .then((response) => {
        dispatch(updateSawmillList(response.data.data));
      })
      .catch((error) => {
        dispatch(updateSawmillList([]));
        notificationActions.enqueueErrorResponse(error);
      });
  };
}

function addSawmillToOrganization(
  organizationId: string,
  name: string,
  callback?: (error?: AxiosError) => void,
) {
  return (dispatch: AppDispatch, getState: () => ApplicationState) => {
    ApiService.createSawmill(organizationId, name)
      .then((response) => {
        const sawmills = getState().sawmills.sawmills ?? [];
        dispatch(
          updateSawmillList([
            ...sawmills,
            {
              id: response.data.id,
              name: response.data.name,
              organizationId,
              users: [],
            },
          ]),
        );
        callback && callback();
      })
      .catch((error) => {
        callback || dispatch(notificationActions.enqueueErrorResponse(error));
        callback && callback(error);
      });
  };
}

function renameSawmill(
  sawmillId: string,
  name: string,
  callback?: (error?: AxiosError) => void,
) {
  return (dispatch: AppDispatch, getState: () => ApplicationState) => {
    ApiService.renameSawmill(sawmillId, name)
      .then(() => {
        const sawmills = getState().sawmills.sawmills ?? [];
        const sawmillIndex = sawmills.findIndex(
          (sawmill) => sawmill.id === sawmillId,
        );
        if (sawmillIndex !== -1) {
          sawmills[sawmillIndex] = { ...sawmills[sawmillIndex], name: name };
          dispatch(updateSawmillList(sawmills));
        }
        callback && callback();
      })
      .catch((error) => {
        callback || dispatch(notificationActions.enqueueErrorResponse(error));
        callback && callback(error);
      });
  };
}

function deleteSawmill(
  sawmillId: string,
  callback?: (error?: AxiosError) => void,
) {
  return (dispatch: AppDispatch, getState: () => ApplicationState) => {
    ApiService.deleteSawmill(sawmillId)
      .then(() => {
        const sawmills = getState().sawmills.sawmills ?? [];

        dispatch(
          updateSawmillList(
            sawmills.filter((sawmill) => sawmill.id !== sawmillId),
          ),
        );

        callback && callback();
      })
      .catch((error) => {
        callback || dispatch(notificationActions.enqueueErrorResponse(error));
        callback && callback(error);
      });
  };
}

function addUserToSawmill(
  sawmillId: string,
  email: string,
  name?: string,
  phone?: string,
  callback?: (error?: AxiosError) => void,
) {
  return (dispatch: AppDispatch, getState: () => ApplicationState) => {
    ApiService.addSawmillUser(sawmillId, { email, name, phone })
      .then(() => {
        const sawmills = getState().sawmills?.sawmills ?? [];
        const sawmillIndex = sawmills.findIndex(
          (sawmill) => sawmill.id === sawmillId,
        );
        if (sawmillIndex !== -1) {
          const sawmill = sawmills[sawmillIndex];
          sawmills[sawmillIndex] = {
            ...sawmill,
            users: [...sawmill.users, { email, name, phone }],
          };
          dispatch(updateSawmillList(sawmills));
        }
        callback && callback();
      })
      .catch((error) => {
        callback || dispatch(notificationActions.enqueueErrorResponse(error));
        callback && callback(error);
      });
  };
}

function assignStacksToSawmill(
  sawmillId: string,
  stackIds: string[],
  callback?: (error?: AxiosError) => void,
) {
  return (dispatch: AppDispatch) => {
    ApiService.assignStacksToSawmill(sawmillId, stackIds)
      .then(() => {
        callback && callback();
      })
      .catch((error) => {
        callback || dispatch(notificationActions.enqueueErrorResponse(error));
        callback && callback(error);
      });
  };
}
function updateSawmillUser(
  sawmillId: string,
  email: string,
  name?: string,
  phone?: string,
  callback?: (error?: AxiosError) => void,
) {
  return (dispatch: AppDispatch, getState: () => ApplicationState) => {
    ApiService.updateSawmillUser(sawmillId, email, {
      name,
      phone,
    })
      .then(() => {
        const sawmills = getState().sawmills.sawmills ?? [];
        const sawmill = sawmills.find((sawmill) => sawmill.id === sawmillId);
        if (sawmill) {
          const sawmillUserIndex = sawmill?.users.findIndex(
            (sawmillUser) => sawmillUser.email === email,
          );

          if (sawmillUserIndex !== -1) {
            const sawmillUser = sawmill.users[sawmillUserIndex];
            sawmill.users[sawmillUserIndex] = { ...sawmillUser, name, phone };
            dispatch(updateSawmillList(sawmills));
          }
        }
        callback && callback();
      })
      .catch((error) => {
        callback || dispatch(notificationActions.enqueueErrorResponse(error));
        callback && callback(error);
      });
  };
}

function removeSawmillUser(
  sawmillId: string,
  email: string,
  callback?: (error?: AxiosError) => void,
) {
  return (dispatch: AppDispatch, getState: () => ApplicationState) => {
    ApiService.removeSawmillUser(sawmillId, email)
      .then(() => {
        const sawmills = getState().sawmills.sawmills ?? [];
        const sawmill = sawmills.find((sawmill) => sawmill.id === sawmillId);
        if (sawmill) {
          sawmill.users = sawmill.users.filter(
            (sawmillUser) => sawmillUser.email !== email,
          );
          dispatch(updateSawmillList(sawmills));
        }
        callback && callback();
      })
      .catch((error) => {
        callback || dispatch(notificationActions.enqueueErrorResponse(error));
        callback && callback(error);
      });
  };
}
